import { useEffect, useRef } from 'react';
import { WebSocketManager, WS_ENDPOINTS } from './websocket';

const BACKGROUND_THRESHOLD_MS = 5 * 60_000;

export const BackgroundReconnectionWatcher = () => {
  const lastHiddenTimeRef = useRef<number | null>(null);

  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.hidden) {
        // App goes to background
        lastHiddenTimeRef.current = Date.now();
      } else {
        // App comes to foreground
        if (lastHiddenTimeRef.current) {
          const backgroundDuration = Date.now() - lastHiddenTimeRef.current;

          if (backgroundDuration > BACKGROUND_THRESHOLD_MS) {
            WebSocketManager.getInstance().forceReconnect(WS_ENDPOINTS.MARKET_DATA);
            WebSocketManager.getInstance().forceReconnect(WS_ENDPOINTS.TRADING);
          }
          lastHiddenTimeRef.current = null;
        }
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);
  return null;
};
